import {
  ReferentielControllerApi,
  SearchCommuneEnlevementResultDto,
} from 'lib_api/lib/api/gen';

import { BaseSearchResult } from 'types/searchResult';

import { useApi } from '../../ApiStoreContext';

import useAsyncSearch from './useAsyncSearch';

export function searchCommuneEnlevement(
  controller: ReferentielControllerApi,
  searchStr: string,
): Promise<SearchCommuneEnlevementResultDto> {
  return controller.searchCommuneEnlevementUsingGET({ searchStr });
}

export function useSearchCommuneEnlevement(): (filters: {
  search: string;
}) => Promise<SearchCommuneEnlevementResultDto> {
  const controller = useApi().ReferentielControllerApi;
  return filters => {
    if (filters.search) {
      return searchCommuneEnlevement(controller, filters.search);
    }
    return Promise.resolve({ communeList: [] });
  };
}

export function useAsyncSearchCommuneEnlevement(): BaseSearchResult<string> {
  const mapResult = (result: SearchCommuneEnlevementResultDto) => {
    return result.communeList;
  };

  const updateFilters = (query?: string) => {
    return { search: query ?? '' };
  };

  const defaultFilter = {
    search: '',
  };

  return useAsyncSearch(
    useSearchCommuneEnlevement,
    mapResult,
    updateFilters,
    defaultFilter,
  );
}
